import { makeRequest } from "@/utils/makeRequest";
import type { AppDispatch } from "..";
import { clearAuth } from "../slices/authSlice";
import { clearProfile } from "../slices/profileSlice";
import { queryClient } from "@/services/queryClient";

export const logOut = () => async (dispatch: AppDispatch) => {
  try {
    await makeRequest.post("/auth/logout");
    dispatch(clearAuth());
    dispatch(clearProfile());
    localStorage.removeItem("nexara_user");

    // CHOOSE ANY
    queryClient.removeQueries();
    queryClient.clear();
    // queryClient.removeQueries({
    //   queryKey: ["recent-transactions"],
    // });

    // queryClient.removeQueries({
    //   queryKey: ["my-notifications"],
    // });

    // queryClient.removeQueries({
    //   queryKey: ["unread-count"],
    // });
  } catch (error) {
    //   getErrorMessage(error);
    console.log(error);
  }
};
